<template>
  <div style="display: inline-block;">
    <span v-if="showAddFolder" id="add_folder" data-test="add_folder" :title="$t('NodeActions.add-folder')" @click.prevent="addChildNode">
      <i class="fa-regular fa-square-plus fa-2x mx-3 pointer"></i>
    </span>
    <span v-if="showDeleteFolder" id="delete_folder" data-test="delete_folder" :title="$t('NodeActions.delete-folder')" @click.prevent="removeFolderNode">
      <i class="fa-solid fa-folder-xmark fa-2x mx-3 pointer"></i>
    </span>
    <span v-if="showRemoveMediaFromCollection" id="remove_media_from_collection" data-test="remove_media_from_collection" :title="$t('NodeActions.remove-media-from-collection')" @click.prevent="removeSelectedMediaFromCollection">
      <i class="fa-solid fa-trash-can-xmark fa-2x mx-3 pointer"></i>
    </span>
  </div>
</template>
<script>
import { DeleteMediaMixin } from '@/mixins/NetworkMedia/DeleteMediaMixin.js';
import { OrganizedTreeService } from '@/services/OrganizedTreeService.js';

export default {
  mixins: [ DeleteMediaMixin ],
  props: {
    tree: {
      type: Array,
      default: null,
    },
    selectedNodeIsFolder: {
      type: Boolean,
      default: false,
    },
    selectedNodeIsMedia: {
      type: Boolean,
      default: false,
    },
    selectedNodeIsRoot: {
      type: Boolean,
      default: false,
    },
    currentlySelectedNode: {
      type: Object,
      default: null,
    },
    selectedMedia: {
      type: [Object, Array],
      default: null,
    },
    collectionSlug: {
      type: String,
      default: null,
    },
    allSelectedNodes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      treeService: new OrganizedTreeService(),
    };
  },
  computed: {
    showAddFolder() {
      return (this.selectedNodeIsFolder || this.selectedNodeIsRoot) && this.allSelectedNodes.length === 1;
    },
    showDeleteFolder() {
      return this.selectedNodeIsFolder && !this.selectedNodeIsRoot && this.allSelectedNodes.length === 1;
    },
    showEditMedia() {
      return this.selectedNodeIsMedia && this.allSelectedNodes.length === 1;
    },
    showDeleteMedia() {
      return this.selectedNodeIsMedia && this.allSelectedNodes.length === 1;
    },
    showRemoveMediaFromCollection() {
      return this.selectedNodeIsMedia && this.allSelectedNodes.length === 1;
    },
  },
  methods: {
    addChildNode() {
      this.currentlySelectedNode.model.addChild({
        text: this.$t('NodeActions.new-node'),
        type: 'folder',
        slug: this.treeService.generateNewFolderSlug(this.tree),
        children: [],
      });
    },
    removeFolderNode() {
      this.$swal.fire({
        //icon: 'warning',
        title: 'Are you sure you want to delete this folder and its contents?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Delete',
        customClass: {
          confirmButton: 'btn btn-danger mx-2',
          cancelButton: 'btn btn-primary mx-2',
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeSelectedMediaFromCollection(false); // do not ask for extra confirmation
          this.removeSelectedNode();
        }
      });
    },
    deleteSelectedMedia() {
      if (this.selectedMedia.networks.length > 1) {
        // do not delete media if part of another network
        this.removeSelectedMediaFromCollection();
        return;
      }
      this.deleteMedia(this.selectedMedia.url.delete || 'networks/media/' + this.selectedMedia.slug).then(() => {
        this.removeSelectedNode();
        this.$bus.emit('collection-reload-event');
        this.$emit('reset-selected-nodes');
      });
    },
    removeSelectedMediaFromCollection(showConfirm = true) {
      let removeMedia = () => {
        this.$http.put('networks/collections/' + this.collectionSlug + '/remove-media/' + this.selectedMedia.slug).then(() => {
          this.removeSelectedNode();
          this.$bus.emit('collection-reload-event');
        });
      };
      if (showConfirm) {
        this.showConfirmPrompt(removeMedia);
      } else {
        removeMedia();
      }
    },
    removeSelectedNode() {
      // splice node with id
      let index = this.currentlySelectedNode.parentItem.indexOf(this.currentlySelectedNode.model);
      this.currentlySelectedNode.parentItem.splice(index, 1);
      this.$emit('reset-selected-nodes');
    },
  },
};
</script>
